import { TuiTooltip, TuiInputDate } from '@taiga-ui/kit';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  TuiHint,
  TuiIcon,
  TuiInput,
  TuiTextfield,
  TuiLabel,
  TuiCalendar,
} from '@taiga-ui/core';
import { WorkflowFormFieldInputDate } from '@features/requests/request-form/components/request-form-workflows/types';
import { HyphenedStringTuiDateTransformerDirective } from '@core/directives';

@Component({
  selector: 'x-input-date-field',
  imports: [
    TuiTextfield,
    TuiLabel,
    TuiCalendar,
    ReactiveFormsModule,
    TuiInputDate,
    TuiHint,
    TuiTooltip,
    TuiIcon,
    TuiInput,
    HyphenedStringTuiDateTransformerDirective,
  ],
  templateUrl: './input-date-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class InputDateFieldComponent {
  field = input.required<WorkflowFormFieldInputDate>();
  control = input.required<FormControl<any>>();
}
